
const filterVal = (obj, predicate) => Object.fromEntries(Object.entries(obj || {}).filter(([, v]) => predicate(v)));

const filterKey = (obj, predicate) => Object.fromEntries(Object.entries(obj || {}).filter(([k]) => predicate(k)));

function getData(routerId, rawData) {
  const filter = Object.keys(filterVal(rawData.Id, (id) => id === routerId));
  const filteredData = {};
  for (const [key, value] of Object.entries(rawData || {})) {
    filteredData[key] = filterKey(value || {}, (x) => filter.includes(x));
  }
  return filteredData;
}

function getTimeKey(time, idData) {
  const deviceTime = idData.Metrics_DeviceTime || {};
  const values = Object.values(deviceTime);
  const idx = values.findIndex((x) => x === time);
  if (idx === -1) throw new Error(`Time ${time} not found`);
  return Object.keys(deviceTime)[idx];
}

function getEnergyConsumption(time, routerId, rawData) {
  const data = getData(routerId, rawData);
  const key = getTimeKey(time, data);
  return (
    data.TypeSpecificData?.[key]?.Ports?.[0]?.AcMeters?.[0]?.TotalEnergyExport?.WattHours ?? 0
  );
}

function getSolarPower(time, routerId, rawData) {
  const data = getData(routerId, rawData);
  const key = getTimeKey(time, data);
  const panels = data.TypeSpecificData?.[key]?.Ports?.[1]?.SolarArray?.Panels ?? [];
  return panels.map((p) => p?.Power?.Watts ?? 0).reduce((a, b) => a + b, 0);
}

function getSolarProduction(time, routerId, rawData) {
  const data = getData(routerId, rawData);
  const key = getTimeKey(time, data);
  return data.TypeSpecificData?.[key]?.Ports?.[2]?.DcMeters?.[0]?.TotalInput?.WattHours ?? 0;
}

function getBatteryCapacity(time, routerId, rawData) {
  const data = getData(routerId, rawData);
  const key = getTimeKey(time, data);
  const packs = data.TypeSpecificData?.[key]?.Ports?.[3]?.BatterySystem?.Packs ?? [];
  return packs
    .map((pack) => pack?.RemainingCapacity?.AmpHours ?? 0)
    .reduce((a, b) => a + b, 0);
}

export function getBigData(time, routerId, rawData) {
  return {
    Time: time,
    EnergyConsumptionLastHour_Wh: getEnergyConsumption(time, routerId, rawData),
    SolarPower_W: getSolarPower(time, routerId, rawData),
    SolarProductionLastHour_Wh: getSolarProduction(time, routerId, rawData),
    BatteryCapacityTot_Ah: getBatteryCapacity(time, routerId, rawData),
  };
}

export function formatDateTime(dateTime) {
  // Takes any valid date, return format as 'YYYY-MM-DD HH:MM:SS.MMM' in user local time
  const dt = new Date(dateTime);
  // eslint-disable-next-line prefer-template
  return dt.getFullYear() + '-'
      + (dt.getMonth() + 1).toString().padStart(2, '0')
      + '-' + dt.getDate().toString().padStart(2, '0')
      + ' ' + dt.getHours().toString().padStart(2, '0')
      + ':' + dt.getMinutes().toString().padStart(2, '0')
      + ':' + dt.getSeconds().toString().padStart(2, '0')
      + '.000';
}
